export const handlePatientClick = (data, navigate) => {
    localStorage.removeItem("lastActiveTab");
    const baseUrl = window.location.origin;
    const patientId = data?.id;
    const url = `${baseUrl}/app/patients-details?patientId=${patientId}`
    window.open(url, "_blank");
};